import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import { UserContext } from "App";
//
import { ExitToApp as ExitToAppIcon } from "@material-ui/icons";
//
import MenuButton from "containers/components/menuItem/MenuButton";
import CenteredView from "containers/centeredView/CenteredView";


function LoginPage({ onLogin }) {
    const userContext = useContext(UserContext);

    return (
        <>
            {userContext ? (
                <Redirect to="/" />
            ) : (
                <CenteredView>
                    Please
                    <MenuButton name="Login" icon={<ExitToAppIcon />} handler={onLogin} />
                    to see this page.
                </CenteredView>
            )}
        </>
    );
}

export default LoginPage;
